import { useCallback, useState } from 'react';
import { useShowNotification } from 'js/components/common/Notifications';
import { join as doJoin, leave as doLeave } from '../actions';

export const getNotification = (error, type) => {
    const { errorCode } = error?.response?.data || error?.data || error || {};

    return {
        iconType: errorCode ? 'error' : 'joinLeaderboardNotification',
        tKey: `playtech.mobile.system.leaderboard.notification.${type}.${errorCode ? 'error' : 'success'}`
    };
};

export default type => ({ leaderboardId }) => {
    const [disabled, setDisabled] = useState(false);
    const showNotification = useShowNotification();
    const onClick = useCallback(() => {
        const join = () => doJoin({ leaderboardId });
        const leave = () => doLeave({ leaderboardId });

        const success = (response) => {
            showNotification(getNotification(response, type));
            setDisabled(false);
        };

        const fail = (error) => {
            showNotification(getNotification(error, type));
            setDisabled(false);
        };

        setDisabled(true);

        (type === 'join' ? join() : leave()).then(success, fail);

    }, [leaderboardId, showNotification]);

    return {
        disabled,
        onClick
    };
};
